/* eslint-disable @typescript-eslint/naming-convention */
import { SearchFilterOption } from "../../../shared/components/search-bar/search-filter/search-filter.component";
import { getAssetCategories, getAssetCoverageStatuses } from "../assets/asset";
import { QuotedAsset } from "./quote.type";

export const getQuoteAssetSearchFilterOptions = (config?: {
  shown?: string[];
  hidden?: string[];
}): SearchFilterOption<QuotedAsset>[] => {
  const { shown, hidden } = config || {};

  return (
    [
      { value: "name", label: "Name", filterByProperty: { asset: { name: true } } },
      {
        value: "serialNumber",
        label: "Serial #",
        filterByProperty: { asset: { serialNumber: true } },
      },
      {
        value: "category",
        label: "Category",
        inputType: "dropdown",
        condition: "$eq",
        options: [...getAssetCategories()],
        filterByProperty: { asset: { category: true } },
      },
      {
        value: "asset.type.model.oem.name",
        label: "OEM",
        filterByProperty: { asset: { type: { model: { oem: { name: true } } } } },
      },
      {
        value: "asset.type.model.name",
        label: "Model #",
        filterByProperty: { asset: { type: { model: { name: true } } } },
      },
      {
        value: "asset.type.name",
        label: "Type",
        filterByProperty: { asset: { type: { name: true } } },
      },
      {
        value: "coverageStatus",
        label: "Coverage Status",
        inputType: "dropdown",
        condition: "$eq",
        options: [...getAssetCoverageStatuses()],
        filterByProperty: { asset: { coverageStatus: true } },
      },
    ] as SearchFilterOption<QuotedAsset>[]
  ).filter((opt) => (shown ? shown.includes(opt.value) : true) && (hidden ? !hidden.includes(opt.value) : true));
};
